export default __webpack_public_path__ + "static/media/searchImg.c1089a16.svg";